import { render, staticRenderFns } from "./customerprofile.vue?vue&type=template&id=39482d21&scoped=true&"
import script from "./customerprofile.vue?vue&type=script&lang=js&"
export * from "./customerprofile.vue?vue&type=script&lang=js&"
import style0 from "./customerprofile.vue?vue&type=style&index=0&id=39482d21&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39482d21",
  null
  
)

export default component.exports